import React from 'react'
import AnimatedList from '../../components/ui/animatedList/animatedList'


const Experience = () => {
  return (
    <div className='container'>
        <h1 className='text-2xl mt-10 font-bold text-purple-600'>Experience</h1>
        <p>Scroll to explore!</p>
        <AnimatedList 
        />
    </div>
  )
}

export default Experience